import request from '../utils/request';

export const fetchData = query => {
    return request({
        url: '../../static/json/table.json',
        method: 'get',
        params: query
    });
};

/**
 * 登录
 */
export const login = (username,password) => {
    return request({
        url: '/userLogin/login',
        method: 'post',
        params: {
          username,
          password
        }
    });
};

/**************************************************/
/**********************首页*********************/
/**************************************************/

/**
 * 统计总数
 */
export const totalStatic = (rolename,zuzhi,attaName) => {
    return request({
        url: '/mmvStatYard/queryByTongJi',
        method: 'post',
        params: {
          rolename,
          zuzhi,
          attaName
        }
    });
};

/**
 * 根据登录权限下的院落名称和时间统计费用 (饼图)
 */
export const costConfiscatePie = (dateStatus, yard) => {
    return request({
        url: '/eamAttaHoldfee/censusCost',
        method: 'post',
        params: {
          dateStatus,
          yard
        }
    });
};

/**
 * 获取右侧通知和公告
 */
export const getNoticeScrollList = (condition, yardName, yardGuid) => {
    return request({
        url: '/problemFeedback/phoneSelectByCondition',
        method: 'post',
        params: {
          condition,
          yardName,
          yardGuid
        }
    });
};

//院落预算统计图
export const getIncome = (yardName, attaName, classClas) => {
    return request({
        url: '/mmvStatYard/queryAll',
        method: 'post',
        params: {
          yardName,
          attaName,
          classClas
        }
    });
};

//查询公告详情
export const getNoticeInfo = id => {
    return request({
        url: '/msgDataMessage/queryById',
        method: 'post',
        params: {
          id
        }
    });
};

//查询公告内容字段
export const getNoticeContent = smsgName => {
    return request({
        url: '/msgAttaMessage/queryAll',
        method: 'post',
        params: {
          smsgName
        }
    });
};
/**************************************************/
/**********************院落管理*********************/
/**************************************************/

/**
 * 列表
 */
export const getYardLists = (yuanluo,limit,page,danyuan,dong,louceng,shi) => {
    return request({
        url: '/yardControllor/queryByuardAndCommunity',
        method: 'post',
        params: {
          yuanluo,
          limit,
          page,
          danyuan,
          dong,
          louceng,
          shi
        }
    });
};

/**
 * 详情
 */
export const yardInfo = yardGuid => {
    return request({
        url: '/yardControllor/queryByYardGuid',
        method: 'post',
        params: {
          yardGuid
        }
    });
};


/**
 * 栋列表
 */
export const getbuildLists = yuanluo => {
    return request({
        url: '/yardControllor/queryByDong',
        method: 'post',
        params: {
          yuanluo
        }
    });
};


/**
 * 单元列表
 */
export const getUnitLists = (leixing, yardGuid) => {
    return request({
        url: '/yardControllor/queryByDanyuan',
        method: 'post',
        params: {
          leixing,
          yardGuid
        }
    });
};

/**
 * 老旧小区改造列表
 */
export const getOldLists = () => {
    return request({
        url: '/tReform/queryAll',
        method: 'post',
        params: {

        }
    });
};

/**
 * 老旧小区改造详情修改
 */
export const oldUpdate = (id, shequ, weijiaona, yijiaona) => {
    return request({
        url: '/tReform/update',
        method: 'post',
        params: {
          id,
          shequ,
          weijiaona,
          yijiaona
        }
    });
};


/**************************************************/
/**********************院落住户*********************/
/**************************************************/

/**
 * 列表
 */
export const getHouseholdLists = (yuanluo,limit,page,statusCode,vague,danyuan,dong,louceng,shi) => {
    return request({
        url: '/MmvAttaHholdControllor/queryByHouseholdAll',
        method: 'post',
        params: {
          yuanluo,
          limit,
          page,
          statusCode,
          vague,
          danyuan,
          dong,
          louceng,
          shi
        }
    });
};
/**
 * 详情
 */
export const householdInfo = hholdGuid => {
    return request({
        url: '/MmvAttaHholdControllor/queryByYardGuid',
        method: 'post',
        params: {
          hholdGuid
        }
    });
};

/**
 * 住户数据导入
 */
export const householdListsImport = formdata => {
    return request({
        url: '/MmvAttaHholdControllor/excel/importMmvAttaHhold',
        method: 'post',
        params: {
          formdata
        }
    });
};

/**
 * 用户审核列表
 */
export const getHouseholdAuditLists = (yuanluo, limit, page, yonghuming) => {
    return request({
        url: '/MmvAttaHholdControllor/queryByYuanluoShenhe',
        method: 'post',
        params: {
          yuanluo,
          limit,
          page,
          yonghuming
        }
    });
};

/**
 * 添加住户
 */
export const addhhold = (dianhua,hujidizhi,huzhuguanxi,shenheren,userid,yuanluo,zhengjianhaoma,zhengjianleixing) => {
    return request({
        url: '/MmvAttaHholdControllor/addzhuhu',
        method: 'post',
        params: {
          dianhua,
          hujidizhi,
          huzhuguanxi,
          shenheren,
          userid,
          yuanluo,
          zhengjianhaoma,
          zhengjianleixing
        }
    });
};

/**
 * 用户审核
 */
export const householdAudit = id => {
    return request({
        url: '/MmvAttaHholdControllor/queryByxiangqing',
        method: 'post',
        params: {
          id
        }
    });
};

/**
 * 匹配住户
 */
export const matchUserLists = (dizhi, yuanluo) => {
    return request({
        url: '/MmvAttaHholdControllor/queryByZhuhu',
        method: 'post',
        params: {
          dizhi,
          yuanluo
        }
    });
};

/**
 * 确认住户信息
 */
export const confirmInfo = (fangchanid, hholdGuid, shenheren, classClas) => {
    return request({
        url: '/MmvAttaHholdControllor/updateByConfirm',
        method: 'post',
        params: {
          fangchanid,
          hholdGuid,
          shenheren,
          classClas
        }
    });
};

/**
 * 移出房产认证信息
 */
export const removeConfirm = (dianhua, hujidizhi, shenfenzhenghao, yuanluo) => {
    return request({
        url: '/MmvAttaHholdControllor/yichu',
        method: 'post',
        params: {
          dianhua,
          hujidizhi,
          shenfenzhenghao,
          yuanluo
        }
    });
};
/**************************************************/
/**********************费用科目*********************/
/**************************************************/


/**
 * 导入费用科目
 */
export const importFee = file => {
    return request({
        url: '/feeDataCharge/excel/import',
        method: 'post',
        data: {
          file
        }
    });
};

/**
 * 根据用户名查询费用下拉框
 */
export const getFeeDropDownData = username => {
    return request({
        url: '/feeDataCharge/selectDropDownBox',
        method: 'post',
        data: {
          username
        }
    });
};

/**
 * 根据用户名查询费用下拉框
 */
export const getFeeLists = (feeName, indexNo, limit, organName, page, sortKey, username) => {
    return request({
        url: '/feeDataCharge/selectByFeeDataCharge',
        method: 'post',
        data: {
          feeName,
          indexNo,
          limit,
          organName,
          page,
          sortKey,
          username
        }
    });
};


/**
 * 费用新增
 */
export const addFee = (classKind, classClas, classType, feeName, accountName, feePeriod, username, classAbout, statusCode, organGuid, organName, roleGuid, roleName) => {
    return request({
        url: '/feeDataCharge/addDataCharge',
        method: 'post',
        data: {
          classKind,
          classClas,
          classType,
          feeName,
          accountName,
          feePeriod,
          username,
          classAbout,
          statusCode,
          organGuid,
          organName,
          roleGuid,
          roleName
        }
    });
};

/**
 * 费用编辑
 */
export const editFee = (indexNo, feePrice, feeCount, feeTotal, feeGuid, createDate, classClas, classType, feeName, accountName, feeStage, accountGuid, organName, statusCode, classAbout) => {
    return request({
        url: '/feeDataCharge/updateFeeDataCharge',
        method: 'post',
        data: {
          indexNo,
          feePrice,
          feeCount,
          feeTotal,
          feeGuid,
          createDate,
          classClas,
          classType,
          feeName,
          accountName,
          feeStage,
          accountGuid,
          organName,
          statusCode,
          classAbout
        }
    });
};

/**
 * 根据用户标识查询他自己添加的银行卡信息
 */
export const queryBankLists = userGuid => {
    return request({
        url: '/feeDataCharge/selectBank',
        method: 'post',
        data: {
          userGuid
        }
    });
};

/**
 * 费用删除
 */
export const deleteFee = (indexNo, feeGuid, createDate, organName) => {
    return request({
        url: '/feeDataCharge/deleteFeeDataCharge',
        method: 'post',
        data: {
          indexNo,
          feeGuid,
          createDate,
          organName
        }
    });
};

/**************************************************/
/**********************费用收缴*********************/
/**************************************************/

/**
 * 费用收缴列表
 */
export const confiscateList = (organName, feeName, feeDate, endDate, statusCode, limit, page, indexNo) => {
    return request({
        url: '/feeAttaIncome/selectFeeAttaIncome',
        method: 'post',
        data: {
          organName,
          feeName,
          feeDate,
          endDate,
          statusCode,
          limit,
          page,
          indexNo
        }
    });
};

/**
 * 费用收缴修改基础信息
 */
export const confiscateUpdate = (organName, indexNo, feeCount, feePrice, feeTotal, feeStage, classAbout) => {
    return request({
        url: '/feeAttaIncome/updateFeeAttaIncome',
        method: 'post',
        data: {
          organName,
          indexNo,
          feeCount,
          feePrice,
          feeTotal,
          feeStage,
          classAbout
        }
    });
};

/**
 * 费用收缴状态变更
 */
export const confiscateStatusUpdate = (indexNoJson, organName, statusCode) => {
    return request({
        url: 'feeAttaIncome/updateStatusCode',
        method: 'post',
        params: {
          indexNoJson,
          organName,
          statusCode
        }
    });
};

/**
 * 费用收缴删除
 */
export const confiscateDel = (organName, indexNo) => {
    return request({
        url: '/feeAttaIncome/deleteFeeAttaIncome',
        method: 'post',
        data: {
          organName,
          indexNo
        }
    });
};

/**
 * 费用收缴住户列表
 */
export const housdholdListByConfiscate = (yuanluo,limit,page,statusCode,vague,danyuan,dong,louceng,shi) => {
    return request({
        // url: '/MmvAttaHholdControllor/queryByFangChan',
        url:'/MmvAttaHholdControllor/queryByFangChanAll',
        method: 'post',
        params: {
          yuanluo,
          limit,
          page,
          statusCode,
          vague,
          danyuan,
          dong,
          louceng,
          shi
        }
    });
};

/**
 * 选择费用科目
 */
export const confiscateItem = organName => {
    return request({
        url: '/feeAttaIncome/selectItem',
        method: 'post',
        data: {
          organName
        }
    });
};

/**
 * 生成单据
 */
export const generateDoc = (organName, roleName, yardGuid, yardName, feeGuid, feeName, feePrice, feeCount, feeStage, feeTotal) => {
    return request({
        url: '/feeAttaIncome/addFeeAttaIncome1',
        method: 'post',
        data: {
          organName,
          roleName,
          yardGuid,
          yardName,
          feeGuid,
          feeName,
          feePrice,
          feeCount,
          feeStage,
          feeTotal
        }
    });
};

/**
 * 线下缴费
 */
export const offlinePay = feeCode => {
    return request({
        url: '/eamAttaHoldfee/updateByFeeCode',
        method: 'post',
        params: {
          feeCode
        }
    });
};


/**************************************************/
/**********************费用账号*********************/
/**************************************************/

/**
 * 添加信息
 */
export const addAccount = (organName,createDate,classType,accountCode,accountName,bankAccount,classAbout,userName,roleName, userGuid) => {
    return request({
        url: '/eamDataAccount/addEamDataAccount',
        method: 'post',
        data: {
          organName,
          createDate,
          classType,
          accountCode,
          accountName,
          bankAccount,
          classAbout,
          userName,
          roleName,
          userGuid
        }
    });
};
/**
 * 查询列表
 */
export const accountList = (feeName, indexNo, limit, organName, page, sortKey, userGuid, accountCode, accountName,
  bankAccount,statusCode) => {
    return request({
        url: '/eamDataAccount/selectByFeeDataCharge',
        method: 'post',
        data: {
          feeName,
          indexNo,
          limit,
          organName,
          page,
          sortKey,
          userGuid,
          accountCode,
          accountName,
          bankAccount,
          statusCode
        }
    });
};
/**
 * 编辑信息
 */
export const editAccount = (indexNo,organName,createDate,classType,accountCode,accountName,bankAccount,classAbout,statusCode,roleName) => {
    return request({
        url: '/eamDataAccount/updateEamDataAccount',
        method: 'post',
        data: {
          indexNo,
          organName,
          createDate,
          classType,
          accountCode,
          accountName,
          bankAccount,
          classAbout,
          statusCode,
          roleName
        }
    });
};

/**
 * 收入详情
 */
export const incomeInfo = ACCOUNT_GUID => {
    return request({
        url: '/eamDataAccount/selectByIn',
        method: 'post',
        params: {
          ACCOUNT_GUID
        }
    });
};

/**
 * 支出详情
 */
export const payInfo = ACCOUNT_GUID => {
    return request({
        url: '/eamDataAccount/selectByOut',
        method: 'post',
        params: {
          ACCOUNT_GUID
        }
    });
};


/**************************************************/
/**********************支出费用*********************/
/**************************************************/

/**
 * 新增院落支出
 */
export const addYardPay = (organName, roleName, yardGuid, yardName, feeGuid, feeName, feePrice, feeCount, feeStage, feeTotal, classAbout) => {
    return request({
        url: '/feeAttaIncomePayment/addFeeAttaIncome1',
        method: 'post',
        data: {
          organName,
          roleName,
          yardGuid,
          yardName,
          feeGuid,
          feeName,
          feePrice,
          feeCount,
          feeStage,
          feeTotal,
          classAbout
        }
    });
};
/**
 * 支出费用删除
 */
export const payDel = (organName, indexNo) => {
    return request({
        url: '/feeAttaIncomePayment/deleteFeeAttaIncome',
        method: 'post',
        data: {
          organName,
          indexNo
        }
    });
};

/**
 * 支出费用列表
 */
export const payList = (organName, feeName, feeDate, endDate, statusCode, limit, page, indexNo) => {
    return request({
        url: '/feeAttaIncomePayment/selectFeeAttaIncome',
        method: 'post',
        data: {
          organName,
          feeName,
          feeDate,
          endDate,
          statusCode,
          limit,
          page,
          indexNo
        }
    });
};

/**
 * 费用支出修改基础信息
 */
export const payUpdate = (organName, indexNo, feeCount, feePrice, feeTotal, feeStage, classAbout) => {
    return request({
        url: '/feeAttaIncomePayment/updateFeeAttaIncome',
        method: 'post',
        data: {
          organName,
          indexNo,
          feeCount,
          feePrice,
          feeTotal,
          feeStage,
          classAbout
        }
    });
};
/**
 * 费用支出状态变更
 */
export const payStatusUpdate = (indexNoJson, organName, statusCode) => {
    return request({
        url: '/feeAttaIncomePayment/updateStatusCode',
        method: 'post',
        params: {
          indexNoJson,
          organName,
          statusCode
        }
    });
};
/**
 * 选择支出费用科目
 */
export const payItem = organName => {
    return request({
        url: '/feeAttaIncomePayment/selectItem',
        method: 'post',
        data: {
          organName
        }
    });
};


/**************************************************/
/**********************核酸检测*********************/
/**************************************************/

/**
 * 上报疫情数据
 */
export const reportEpidemic = (jcglrs,jjglrs,jrpcrs,kmhsjcrs,sptjbrs,wghpcrs,xzgkrs,ymjzrs,zdrqhsrs) => {
    return request({
        url: '/tPrevention/save',
        method: 'post',
        params: {
          jcglrs,
          jjglrs,
          jrpcrs,
          kmhsjcrs,
          sptjbrs,
          wghpcrs,
          xzgkrs,
          ymjzrs,
          zdrqhsrs
        }
    });
};

/**
 * 疫情数据列表
 */
export const getReportEpidemic = (limit, page) => {
    return request({
        url: '/tPrevention/queryAll',
        method: 'post',
        params: {
          limit,
          page
        }
    });
};

/**
 * 新增
 * @param {Object} carouselTime 轮播时间，单位：秒
 * @param {Object} code 编码
 * @param {Object} name 名称
 */
// export function apiPlatformAdPositionAdd(carouselTime, code, name) {

// 	return request({
// 		url: 'talent-room-ad/platform/platformAdPosition/add',
// 		method: 'post',
// 		data: {

// 			carouselTime,
// 			code,
// 			name
// 		}

// 	});
// }
/**
 * 防疫志愿者查询-根据条件查询所有
 */
 export const getFangyiVolunteer = (
    name,
    phone,
    yxfwsq,
    limit,
    page
 ) => {
    return request({
        url: '/fangyiVolunteer/queryAll',
        method: 'post',
        params: {
            name,
            phone,
            yxfwsq,
            limit,
            page
        }
    });
};
/**
 * 防疫志愿者查询-通过主键查询单条数据
 */
 export const getFangyiVolunteerQueryById = (name,phone,yxfwsq,limit,page) => {
    return request({
        url: '/fangyiVolunteer/queryById',
        method: 'post',
        params: {
            name,
            phone,
            yxfwsq,
            limit,
            page
        }
    });
};
/**
 * 防疫志愿者编辑-修改
 */
 export const updateFangyiVolunteer = (data) => {
    return request({
        url: '/fangyiVolunteer/update',
        method: 'post',
        data: data
    });
};
/**
 * 防疫志愿者删除
 */
 export const daleteFangyiVolunteer = (data) => {
    return request({
        url: '/fangyiVolunteer/dalete',
        method: 'post',
        data: data
    });
};
/**
 * 社区报备查询-根据条件查询所有
 */
 export const getShequBaobei = (
    xingming,
    xiaoqu,
    shi,
    phone,
    dong,
    danyuan,
    ceng,
    limit,
    page,
    shequ
 ) => {
    return request({
        url: '/shequBaobei/queryAll',
        method: 'post',
        params: {
            xingming,
            xiaoqu,
            shi,
            phone,
            dong,
            danyuan,
            ceng,
            limit,
            page,
            shequ
        }
    });
};
/**
 * 社区报备详情-通过主键查询单条数据
 */
 export const getShequBaobeiQueryById = (data) => {
    return request({
        url: '/shequBaobei/queryById',
        method: 'post',
        data: data
    });
};
/**
 * 社区报备 院落管理-根据院落名称查询yardGuid
 */
 export const updateQueryByYardName = (yuanluo) => {
    return request({
        url: '/yardControllor/queryByYardName',
        method: 'post',
        params: {
            yuanluo
        }
    });
};
/**
 * 社区报备编辑-修改
 */
 export const updateShequBaobei = (data) => {
    return request({
        url: '/shequBaobei/update',
        method: 'post',
        data: data
    });
};
/**
 * 社区报备删除
 */
 export const daleteShequBaobei = (data) => {
    return request({
        url: '/shequBaobei/dalete',
        method: 'post',
        data: data
    });
};
/**
 * 核酸检测点-根据条件查询所有
 */
 export const getHesuanjiancedian = (
    xiaoqu,
    lianxiren,
    phone,
    limit,
    page) => {
    return request({
        url: '/hesuanjiancedian/queryAll',
        method: 'post',
        params: {
            xiaoqu,
            lianxiren,
            phone,
            limit,
            page
        }
    });
};
/**
 * 核酸检测点详情-通过主键查询单条数据
 */
 export const getHesuanjiancedianQueryById = (data) => {
    return request({
        url: '/hesuanjiancedian/queryById',
        method: 'post',
        data: data
    });
};

/**
 * 核酸检测点编辑-新增
 */
 export const addHesuanjiancedian = (data) => {
    return request({
        url: '/hesuanjiancedian/add',
        method: 'post',
        data: data
    });
};
/**
 * 核酸检测点编辑-修改
 */
 export const updateHesuanjiancedian = (data) => {
    return request({
        url: '/hesuanjiancedian/update',
        method: 'post',
        data: data
    });
};
/**
 * 核酸检测点删除
 */
 export const daleteHesuanjiancedian = (data) => {
    return request({
        url: '/hesuanjiancedian/dalete',
        method: 'post',
        data: data
    });
};

/**
 * 同住人报备-根据条件查询所有
 */
 export const getTongzhurenBaobei = (
    name,
    xiaoqu,
    shi,
    phone,
    dong,
    danyuan,
    ceng,
    limit,
    page,
    shequ) => {
    return request({
        url: '/tongzhurenBaobei/queryAll',
        method: 'post',
        params: {
            name,
            xiaoqu,
            shi,
            phone,
            dong,
            danyuan,
            ceng,
            limit,
            page,
            shequ
        }
    });
};
/**
 * 同住人报备详情-通过主键查询单条数据
 */
 export const getTongzhurenBaobeiQueryById = (data) => {
    return request({
        url: '/tongzhurenBaobei/queryById',
        method: 'post',
        data: data
    });
};
/**
 * 同住人报备编辑-修改
 */
 export const updateTongzhurenBaobei = (data) => {
    return request({
        url: '/tongzhurenBaobei/update',
        method: 'post',
        data: data
    });
};
/**
 * 同住人报备删除
 */
 export const daleteTongzhurenBaobeidian = (data) => {
    return request({
        url: '/tongzhurenBaobei/dalete',
        method: 'post',
        data: data
    });
};

/**
 * 风险区域-根据条件查询所有
 */
 export const getFengxianquyu = (biaoti,danwei,limit,page) => {
    return request({
        url: '/fengxianquyu/queryAll',
        method: 'post',
        params: {
            biaoti,
            danwei,
            limit,
            page
        }
    });
};
/**
 * 风险区域详情-通过主键查询单条数据
 */
 export const getFengxianquyuQueryById = (data) => {
    return request({
        url: '/fengxianquyu/queryById',
        method: 'post',
        data: data
    });
};
/**
 * 风险区域详情-通过主键查询单条数据
 */
 export const addFengxianquyu= (data) => {
    return request({
        url: '/fengxianquyu/add',
        method: 'post',
        data: data
    });
};
/**
 * 风险区域编辑-修改
 */
 export const updateFengxianquyu = (data) => {
    return request({
        url: '/fengxianquyu/update',
        method: 'post',
        data: data
    });
};
/**
 * 风险区域删除
 */
 export const daleteFengxianquyu = (data) => {
    return request({
        url: '/fengxianquyu/dalete',
        method: 'post',
        data: data
    });
};

/**
 * 疫情资讯-根据条件查询所有
 */
 export const getYiqingzixun = (biaoti,danwei,limit,page) => {
    return request({
        url: '/yiqingzixun/queryAll',
        method: 'post',
        params: {
            biaoti,
            danwei,
            limit,
            page
        }
    });
};
/**
 * 疫情资讯-通过主键查询单条数据
 */
 export const getYiqingzixunQueryById = (data) => {
    return request({
        url: '/yiqingzixun/queryById',
        method: 'post',
        data: data
    });
};
/**
 * 疫情资讯-通过主键查询单条数据
 */
 export const addYiqingzixun= (data) => {
    return request({
        url: '/yiqingzixun/add',
        method: 'post',
        data: data
    });
};
/**
 * 疫情资讯编辑-修改
 */
 export const updateYiqingzixun = (data) => {
    return request({
        url: '/yiqingzixun/update',
        method: 'post',
        data: data
    });
};
/**
 * 疫情资讯删除
 */
 export const daleteYiqingzixun = (data) => {
    return request({
        url: '/yiqingzixun/dalete',
        method: 'post',
        data: data
    });
};

/**
 * 系统设置 短信配置-修改
 */
 export const updateUpdateAliyunConfig = (data) => {
    return request({
        url: '/userLogin/updateAliyunConfig',
        method: 'post',
        data: data
    });
};
/**
 * 系统设置 短信配置-查询
 */
 export const getSelectAliyunConfig = (data) => {
    return request({
        url: '/userLogin/selectAliyunConfig',
        method: 'post'
    });
};

/**
 * 日志管理-根据条件查询所有
 */
 export const getSysLogQueryAll = (operation,limit,page) => {
    return request({
        url: '/sysLog/queryAll',
        method: 'post',
        params: {
            operation,
            limit,
            page
        }
    });
};

/**
 * 组织管理-根据条件查询所有
 */
 export const getMmvAttaYardQueryAll = (yardName) => {
    return request({
        url: '/mmvAttaYard/queryAll',
        method: 'post',
        params: {
            yardName
        }
    });
};
/**
 * 组织信息-根据条件查询所有
 */
 export const getEamDataOrganQueryAll = (yardName) => {
    return request({
        url: '/eamDataOrgan/queryAll',
        method: 'post',
        params: {
            yardName
        }
    });
};

/**
 * 我的小区删除
 */
 export const daleteMmvAttaYard = (id) => {
    return request({
        url: '/mmvAttaYard/dalete',
        method: 'post',
        params: {
            id
        }
    });
};

/**
 * 我的小区添加
 */
 export const addMmvAttaYard = (data) => {
    return request({
        url: '/mmvAttaYard/add',
        method: 'post',
        data: data
    });
};
/**
 * 组织信息添加
 */
 export const addEamDataOrgan = (data) => {
    return request({
        url: '/eamDataOrgan/add',
        method: 'post',
        data: data
    });
};
/**
 * 组织信息修改
 */
 export const updateEamDataOrgan = (data) => {
    return request({
        url: '/eamDataOrgan/update',
        method: 'post',
        data: data
    });
};
/**
 * 雇员属性-根据条件查询所有
 */
 export const getEamAttaClerkQueryAll = (organName, classClas) => {
    return request({
        url: '/eamAttaClerk/queryAll',
        method: 'post',
        params: {
            organName,
            classClas
        }
    });
};
/**
 * 雇员属性添加
 */
 export const addEamAttaClerk = (data) => {
    return request({
        url: '/eamAttaClerk/add',
        method: 'post',
        data: data
    });
};
/**
 * 雇员属性 删除
 */
 export const daleteEamAttaClerk = (id) => {
    return request({
        url: '/eamAttaClerk/dalete',
        method: 'post',
        params: {
            id
        }
    });
};
/**
 * 属性信息-根据条件查询所有
 */
 export const getEamAttaOrganQueryAll = (organName,classClas) => {
    return request({
        url: '/eamAttaOrgan/queryAll',
        method: 'post',
        params: {
            organName,
            classClas
        }
    });
};
/**
 * 属性信息添加
 */
 export const addEamAttaOrgan = (data) => {
    return request({
        url: '/eamAttaOrgan/add',
        method: 'post',
        data: data
    });
};
/**
 * 属性信息 删除
 */
 export const daleteEamAttaOrgan = (id) => {
    return request({
        url: '/eamAttaOrgan/dalete',
        method: 'post',
        params: {
            id
        }
    });
};
/**
 * 组织信息 删除
 */
 export const daleteEamDataOrgan = (id) => {
    return request({
        url: '/eamDataOrgan/dalete',
        method: 'post',
        params: {
            id
        }
    });
};
/**
 * 用户管理-根据条件查询所有
 */
 export const gettUserQueryAll = (username, name, phone, certGuid, limit, page) => {
    return request({
        url: '/tUser/queryAll',
        method: 'post',
        params: {
            username,
            name,
            phone,
            certGuid,
            limit,
            page
        }
    });
};
/**
 * 用户管理添加
 */
 export const addtUser = (username, name, password,certGuid,gender, geoid) => {
    return request({
        url: '/tUser/add',
        method: 'post',
        params: {
            username,
            name,
            password,
            certGuid,
            gender,
            geoid
        }
    });
};
export const updatetUser = (id,username, name, password,certGuid, roleid, geoid) => {
    return request({
        url: '/tUser/update',
        method: 'post',
        params: {
            id,
            username,
            name,
            password,
            certGuid,
            roleid,
            geoid
        }
    });
};
/**
 * 用户管理 删除
 */
 export const daletetUser = (id) => {
    return request({
        url: '/tUser/dalete',
        method: 'post',
        params: {
            id
        }
    });
};
// 用户管理-注册用户列表查询
export const gettUserquery = (name, certGuid, phone, gender, limit, page) => {
    return request({
        url: '/tUser/query',
        method: 'post',
        params: {
            name,
            certGuid,
            phone,
            gender,
            limit,
            page
        }
    });
};
export const updatetUser1 = (id, name, nickname,certGuid, phone, gender, avatarurl, openId) => {
    return request({
        url: '/tUser/update',
        method: 'post',
        params: {
            id,
            name,
            nickname,
            certGuid,
            phone,
            gender,
            avatarurl,
            openId
        }
    });
};


// WEBPACK FOOTER //
// ./src/api/index.js